<template>
	<div class="sf-flex-column">
		<!-- ContentView 검색조건 영역 시작 -->
		<div class="sf-col sf-col-4">
			<sf-card class="p-0 card_bg">
				<search-view :scrId="scrId" @PopupOpen="PopupOpen" />
			</sf-card>
		</div>
		<!-- ContentView 검색조건 영역 종료 -->
		<!-- ContentView 테이블 영역 시작 -->
		<div class="sf-col sf-col-20">
			<table-view :scrId="scrId" />
		</div>
		<!-- ContentView 테이블 영역 종료 -->

		<!-- 팝업부분 영역 시작 -->
		<!-- <user-popup-view ref="userPopupView" @SendData="sendData" @Refresh="Refresh" :scrId="scrId" /> -->
		<!-- 팝업부분 영역 종료 -->
	</div>
</template>

<script>
// import UserPopupView from '../../UserPopup/UserPopupView.vue';
import SearchView from './Search/SearchView.vue';
import TableView from './Table/TableView.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
		// , userName: { type: String, default: '' }
	},
	//	components: { SearchView, TableView },
	components: { SearchView, TableView },
	methods: {
		PopupOpen(param) {
			//console.log('ContentView 에서의 this.userName 값 ::::: ', param.userName);
			this.$refs.userPopupView.open(param); //.open(param);
		},
		sendData(param) {
			alert('최종 팝업화면에서 가지고온 데이터 ::::: userId 는 ' + param.userId + ', userName은 ' + param.userName);
		},
		Refresh(currentPage = 1, pageUnit = 10) {
			this.$refs.UserPopupView.searchList(currentPage, pageUnit);
		}
	}
};

//import SearchView from './Search/SearchView.vue';
//import TableView from './Table/TableInfoTable.vue';

/*
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components : {
		SearchView //, TableView
	}
	
	//components: { SearchView, TableView }
};
*/
</script>

<style></style>
